const pillars = [
  {
    title: 'System Design',
    subtitle: 'Architecture',
    icon: '🏗️',
    color: '#3b82f6',
    goal: 'Treat the agent as an orchestra, not a single script.',
    checks: [
      'Data flow between LLM, tools, DBs, and sub-agents is clearly defined',
      'Component failure & multi-agent coordination strategy exists',
      'Structure prevents uncoordinated service spaghetti',
    ],
  },
  {
    title: 'Tool & Contract Design',
    subtitle: 'Schemas',
    icon: '🔧',
    color: '#22d3ee',
    goal: 'Eliminate ambiguity. The agent must not "imagine" inputs.',
    checks: [
      'All tool schemas have strict types, required fields, and clear examples',
      'UserID enforces int/uuid pattern — not just any string',
      'I/O contracts prevent hallucinated params on critical tasks',
    ],
  },
  {
    title: 'Retrieval Engineering',
    subtitle: 'RAG',
    icon: '📚',
    color: '#a78bfa',
    goal: 'Ensure the context provided is signal, not noise.',
    checks: [
      'Chunking strategy balances detail dilution vs context loss',
      'Embedding model is appropriate for domain data',
      'Re-ranking step scores & prioritizes docs before LLM context',
    ],
  },
  {
    title: 'Reliability Engineering',
    subtitle: 'Resilience',
    icon: '🛡️',
    color: '#22c55e',
    goal: 'Prevent cascading failures and infinite loops.',
    checks: [
      'Exponential backoff retry logic for API failures',
      'Timeouts prevent indefinite hanging on responses',
      'Fallbacks & circuit breakers when primary tools fail',
    ],
  },
  {
    title: 'Security & Safety',
    subtitle: 'Hardening',
    icon: '🔒',
    color: '#ef4444',
    goal: 'Treat the agent as an attack surface.',
    checks: [
      'Prompt injection defenses ignore malicious instructions',
      'Agent operates on principle of least privilege',
      'Input validation & output filtering block policy violations',
    ],
  },
  {
    title: 'Evaluation & Observability',
    subtitle: 'Telemetry',
    icon: '📊',
    color: '#f59e0b',
    goal: '"You cannot improve what you cannot measure."',
    checks: [
      'Complete trace timeline of decisions, tool calls, retrievals',
      'Metrics tracked: success rate, latency, cost per task',
      'Automated regression tests with known good answers',
    ],
  },
  {
    title: 'Product Thinking',
    subtitle: 'UX',
    icon: '✨',
    color: '#f472b6',
    goal: 'Build trust with unpredictable systems.',
    checks: [
      'Agent communicates confidence level clearly to user',
      'Graceful path for clarification or human escalation',
      'Error messages are user-friendly, not cryptic',
    ],
  },
];

function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function renderDashboard() {
  const cards = pillars
    .map(
      (p, idx) => `
    <article class="card" data-index="${idx}">
      <div class="card-header">
        <div class="icon" style="background:${p.color}15;color:${p.color}">${p.icon}</div>
        <div>
          <h2>${escapeHtml(p.title)}</h2>
          <span>${escapeHtml(p.subtitle)}</span>
        </div>
      </div>
      <p><strong>Goal:</strong> ${escapeHtml(p.goal)}</p>
      <ul class="checklist">
        ${p.checks.map((c) => `<li>${escapeHtml(c)}</li>`).join('')}
      </ul>
    </article>
  `
    )
    .join('');

  return `
    <header>
      <h1>Aishwin Agent Harness</h1>
      <p>Production-grade audit checklist for agent engineering. Transition from prompt recipes to resilient system design.</p>
      <div class="meta">
        <span class="dot"></span>
        <span>System Operational</span>
      </div>
    </header>
    <main class="container">
      <div class="grid">
        ${cards}
      </div>
    </main>
    <footer>
      Deployed via CI/CD to Cloudflare Pages · aiagent.pages.dev
    </footer>
  `;
}

document.addEventListener('click', (e) => {
  const li = e.target.closest('.checklist li');
  if (!li) return;
  li.classList.toggle('checked');
});
